import React from 'react';
import { Grid, Card, CardContent, Typography, CircularProgress, Box } from '@mui/material';
import {
  People,
  LocalHospital,
  CheckCircle,
  ReceiptLong,
  Biotech,
} from '@mui/icons-material';

const Statistics = ({ stats, loading }) => {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  const statCards = [
    {
      title: 'Total Patients',
      value: stats?.totalPatients || 0,
      icon: <People sx={{ fontSize: 40 }} />,
      color: '#1976d2',
    },
    {
      title: 'Total Practitioners',
      value: stats?.totalPractitioners || 0,
      icon: <LocalHospital sx={{ fontSize: 40 }} />,
      color: '#2e7d32',
    },
    {
      title: 'Active Patients',
      value: stats?.activePatients || 0,
      icon: <CheckCircle sx={{ fontSize: 40 }} />,
      color: '#ed6c02',
    },
    {
      title: 'Active Practitioners',
      value: stats?.activePractitioners || 0,
      icon: <CheckCircle sx={{ fontSize: 40 }} />,
      color: '#9c27b0',
    },
    {
      title: 'Total Orders',
      value: stats?.totalOrders || stats?.totalTests || 0,
      icon: <ReceiptLong sx={{ fontSize: 40 }} />,
      color: '#d32f2f',
    },
    {
      title: 'Total Labs',
      value: stats?.totalLabs || stats?.labCount || 0,
      icon: <LocalHospital sx={{ fontSize: 40 }} />,
      color: '#00838f',
    },
    {
      title: 'Total Tests',
      value: stats?.testCount || stats?.totalTests || 0,
      icon: <Biotech sx={{ fontSize: 40 }} />,
      color: '#5d4037',
    },
  ];

  return (
    <Grid container spacing={3}>
      {statCards.map((stat, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card
            sx={{
              height: '100%',
              backgroundColor: 'white',
              borderRadius: 3,
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
              },
            }}
          >
            <CardContent>
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                <Box sx={{ 
                  color: stat.color,
                  '& .MuiSvgIcon-root': {
                    fontSize: { xs: 32, sm: 40 }
                  }
                }}>
                  {stat.icon}
                </Box>
                <Typography 
                  variant="h3" 
                  component="div" 
                  fontWeight="bold"
                  sx={{
                    fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' }
                  }}
                >
                  {stat.value}
                </Typography>
              </Box>
              <Typography 
                variant="h6" 
                color="text.secondary"
                sx={{
                  fontSize: { xs: '0.875rem', sm: '1rem' }
                }}
              >
                {stat.title}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default Statistics;

